import React from 'react';
import Navbar from '../components/Navbar';
import Headings from '../components/Headings';
import Slider from '../components/Slider';
import { framingSlides } from '../data/data';
import InfoBlock from '../components/InfoBlock';
import CtaBanner from '../components/CtaBanner';
import Footer from '../components/Footer';

const Framing = () => {
  return (
    <>
      <Navbar />
      <Headings headingName="Framing" />
      <InfoBlock
        tagLine="Structural Framing Built to Last"
        simpleText="Expert framing services for residential and commercial construction, built to code with lasting durability."
      />
      <Slider framingSlides={framingSlides} />
      <CtaBanner />
      <Footer />
    </>
  );
};

export default Framing;
